/* tslint:disable */
/* eslint-disable */
/**
 * Poznejme Cesko API
 * Poznejme Cesko API Documentation
 *
 * OpenAPI spec version: v1.0.0
 * Contact: jan.fara@cleevio.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import globalAxios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { FindAllTournamentOpenQuestionResult } from '../models';
/**
 * TournamentOpenQuestionsApi - axios parameter creator
 * @export
 */
export const TournamentOpenQuestionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get tournament open questions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllOpenQuestions: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/tournaments/openQuestions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            // authentication x-platform required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-Platform")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-Platform"] = localVarApiKeyValue;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TournamentOpenQuestionsApi - functional programming interface
 * @export
 */
export const TournamentOpenQuestionsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get tournament open questions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllOpenQuestions(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Array<FindAllTournamentOpenQuestionResult>>>> {
            const localVarAxiosArgs = await TournamentOpenQuestionsApiAxiosParamCreator(configuration).findAllOpenQuestions(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * TournamentOpenQuestionsApi - factory interface
 * @export
 */
export const TournamentOpenQuestionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get tournament open questions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllOpenQuestions(options?: AxiosRequestConfig): Promise<AxiosResponse<Array<FindAllTournamentOpenQuestionResult>>> {
            return TournamentOpenQuestionsApiFp(configuration).findAllOpenQuestions(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TournamentOpenQuestionsApi - object-oriented interface
 * @export
 * @class TournamentOpenQuestionsApi
 * @extends {BaseAPI}
 */
export class TournamentOpenQuestionsApi extends BaseAPI {
    /**
     * 
     * @summary Get tournament open questions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentOpenQuestionsApi
     */
    public async findAllOpenQuestions(options?: AxiosRequestConfig) : Promise<AxiosResponse<Array<FindAllTournamentOpenQuestionResult>>> {
        return TournamentOpenQuestionsApiFp(this.configuration).findAllOpenQuestions(options).then((request) => request(this.axios, this.basePath));
    }
}
